import { Api } from '@/domains/api';
export function getRawSensorData(controllerId, sensorRequest) {
    return Api.Sensor.getRawRoomSensorData(controllerId, sensorRequest);
}
export function getSetpointData(controllerId, sensorRequest) {
    return Api.Sensor.getSetpointData(controllerId, sensorRequest);
}
export function getSensorData(controllerId, sensorRequest) {
    return Api.Sensor.getRoomSensorData(controllerId, sensorRequest);
}
